<script>
export default {
    data() {
        return {
            isOpen: false,
        };
    },

    methods: {
        open() {
            this.isOpen = true;
        },

        close() {
            this.isOpen = false;
        },

        logout() {
            this.$axios.post(route('logout')).then(response => {
                window.location = route('home');
            });
        },
    },
};
</script>
